<template lang="pug">
  .component-map.card#fullscreenme
    .container
      .row.full-width
        .column.p-0
          GoogleMapContainer
            google-map(
              v-if="mapCenter.lat !== 0 && mapCenter.lng !== 0",
              :searchBar="false",
              :api-key="mapsAPI",
              :center="mapCenter",
              :zoom=" 13",
              :mapTypeId="'roadmap'",
              :scrollwheel="false",
              :zoomControl="false",
              :mapTypeControl="true",
              :listenForClick="true",
              ref="map")
              .allowed(v-for="(allowed) in zones['allowed']")
                google-map-polygon(v-for="poly in allowed.poly", :positions="poly", color="green", fillColor="green")
              .forbidden(v-for="(forbidden) in zones['forbidden']")
                google-map-polygon(v-for="poly in forbidden.poly", :positions="poly", color="red", fillColor="red")
              .undesirable(v-for="(undesirable) in zones['undesirable']")
                google-map-polygon(v-for="poly in undesirable.poly", :positions="poly", color="yellow", fillColor="yellow")
              google-map-marker-cluster(ref="cluster")
                google-map-marker(
                  v-for='(reservation, index) in reservations',
                  :key='reservation.id',
                  :ref="'marker-'+reservation.id",
                  :icon="vehicleInRange(reservation.vehicle.in_range)",
                  :position="{lat: reservation.vehicle.position.latitude, lng: reservation.vehicle.position.longitude}",
                  :title='reservation.vehicle.model',
                  :label="reservation.vehicle.model",
                  :labelOrigin="[15,30]",
                )
                  reservation(:item="reservation", type="sentinel")
      .row
        .column
          .row
            .column.small-3
              label Sentinellable
                select(v-model="search.sentinellable")
                  option(:value="null") No filter
                  option(value='App\\Models\\Client') Client
                  option(value='App\\Models\\Reservation') Reservation
            .column
              label Go Full
              .button(@click="fullScreen") Full screen
          base-list(:component="component", :search="search", :data-loader="loadAlarms", ref="baseList" )


</template>
<script type="text/babel">

  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import Vehicle from 'components/backoffice/Vehicle'
  import GoogleMap from '../../lib/map/GoogleMap.vue'
  import GoogleMapMarker from '../../lib/map/GoogleMapMarker.vue'
  import GoogleMapCircle from '../../lib/map/GoogleMapCircle.vue'
  import GoogleMapPolygon from '../../lib/map/GoogleMapPolygon'
  import GoogleMapMarkerCluster from '../../lib/map/GoogleMapMarkerCluster.vue'
  import GoogleMapDirectionsService from '../../lib/map/GoogleMapDirectionsService'
  import GoogleMapContainer from '../../components/backoffice/GoogleMapContainer'
  import SelectizeVehicleType from '../../components/structure/ui/lists/selectize/SelectizeVehicleType'
  import ActionButton from '../../components/structure/ui/ActionButton'
  import InputSwitch from '../../components/structure/ui/InputSwitch'
  import Reservation from '../../components/backoffice/Reservation'
  import Alarm from '../../components/backoffice/Alarm'
  import BaseList from './BaseList'

  export default {
    name: 'Sentinel',
    data() {
      return {
        reservations: [],
        alarms: [],
        component: require('components/backoffice/Sentinel'),

        pooler: null,
        mapCenter: {
          lat: 0,
          lng: 0,
        },
        userPosition: null,
        zones: [],
        search: {
          sentinellable: null
        }
      }
    },

    methods: {
      test(index) {
        const clusterer = this.$refs.cluster

        const map = clusterer.getMap()

        map.panTo(this.$refs.cluster.markers[index].position)
        map.setZoom(20)
        google.maps.event.trigger(this.$refs.cluster.markers[index], 'click')
      },
      pool() {
        this.pooler = setInterval(() => {
          this.loadReservations()
          this.$refs.baseList.loadData(1)
        }, 15000)
      },
      optionSelected(obj) {
        this.body.vehicle_type_id = obj.id
      },
      optionRemoved() {
        this.body.vehicle_type_id = null
      },
      loadReservations() {
        return KeplerBackofficeSdk.reservations.list(1, 25, {
          status: 'STARTED'
        }).all((data) => {
          return data
        })
      },

      loadAlarms(callback, page, resultsPerPage, search) {
        return KeplerBackofficeSdk.sentinel.list(page, resultsPerPage, search).all((data) => {
          callback(data)
        })
      },
      vehicleInRange(inRange) {
        return inRange ? '/static/map_pin_blue.png' : '/static/map_pin_red.png'
      },

      fullScreen() {
        if (
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement
        ) {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          }
        } else {
          let element = document.getElementById('fullscreenme')
          if (element.requestFullscreen) {
            element.requestFullscreen()
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen()
          } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen()
          }
        }
      }

    },
    components: {
      BaseList,
      Alarm,
      Reservation,
      InputSwitch,
      ActionButton,
      SelectizeVehicleType,
      GoogleMapContainer,
      GoogleMapDirectionsService,
      Vehicle,
      GoogleMap,
      GoogleMapMarker,
      GoogleMapCircle,
      GoogleMapMarkerCluster,
      GoogleMapPolygon
    },
    computed: {
      mapsAPI: function () {
        return window.env.GOOGLE_MAPS_KEY
      }
    },
    created() {
      ///const alarms = this.loadAlarms()
      KeplerBackofficeSdk.reservations.list(1, 25, {
        status: 'STARTED'
      }).all((response) => {
        this.reservations = response.items.filter((item) => {
          return item.maintenance == false
        })
      })


      this.pool()
    },
    destroyed() {
      clearInterval(this.pooler)
    },
    mounted() {
      KeplerBackofficeSdk.configuration.get((data) => {
        this.mapCenter.lat = data.application.application_default_latitude.value
        this.mapCenter.lng = data.application.application_default_longitude.value
      })

      KeplerBackofficeSdk.zones.list.grouped((data) => {
        this.zones = data
      })
    }
  }


</script>
<style lang="sass" rel="stylesheet/sass">
  .component-map
    width: 100%
    overflow-y: scroll

    #fullscreenme
      overflow-y: scroll

    .google-map-container
      height: 100%

    .row
      &.full-width
        max-width: 100%

    .list
      max-height: 650px
      overflow-x: hidden
      overflow-y: scroll

    .toggles
      position: absolute
      padding: 2em
      right: 0
      background: white
      width: 300px

      .content
        display: flex
        text-align: center
        flex-direction: column
        justify-content: center
</style>



// WEBPACK FOOTER //
// Sentinel.vue?279a4a72